export const EVENT_LAYOUT_STACK = 'stack';
export const EVENT_LAYOUT_NONE = 'none';
